import React, { useContext } from 'react';
import styles from './EducationalPost.module.css';
import { LanguageContext } from '../LanguageContext/LanguageContext';
import { assests } from '../../assets/assests';

const EducationalPost = ({ fifthData }) => {
  const { direction } = useContext(LanguageContext);
  const isRTL = direction === 'rtl';

  if (!fifthData) return <p>Loading...</p>; // Handle loading state

  // Use fifthData for title and mediaContent
  const title = isRTL ? fifthData.titleInArab : fifthData.titleInEng;
  const mediaContent = fifthData.mediaContent || [];

  return (
    <div className={styles.container}>
      <div>
        <h1>{title}</h1>
      </div>

      <div className={styles.cardsWrapper}>
        {mediaContent.map((content, index) => (
          <div key={index} className={styles.card}>
                  <a style={{textDecoration:"none"}} href={content.instagramLink} target="_blank" rel="noopener noreferrer">
            <img src={content.imageUrl} alt="Educational Post" />
            <h5>{isRTL ? content.description : content.other}</h5>
            <div className={styles.mores}>

                <p>{isRTL ? "قراءة المنشورات": "More"}</p> {/* Hardcoded text based on language */}
              <a href={content.instagramLink} target="_blank" rel="noopener noreferrer">
                <div>
                  <img src={assests.instagramlogo} alt="Instagram Logo" />
                </div>
              </a>
            </div>
            </a>
          </div>

        ))}
      </div>
    </div>
  );
};

export default EducationalPost;
